import Image from "next/image";

/**
 * Marque seule (cheval + maillons), sans le mot « Horsink » : le libellé est
 * déjà à côté dans la sidebar, et le logo complet serait illisible en 32 px.
 * Le PNG est détouré, il tient donc sur fond clair comme sur fond sombre.
 */
export default function Logo({ className }: { className?: string }) {
  return (
    <Image
      src="/logo.png"
      width={64}
      height={64}
      priority
      className={
        className ??
        "me-1 size-8 transition-all group-data-collapsible:size-6 group-data-[collapsible=icon]:size-8"
      }
      alt="Horsink"
    />
  );
}

/** Logo complet (marque + mot-symbole), pour les écrans sans sidebar. */
export function LogoFull({ className }: { className?: string }) {
  return (
    <Image
      src="/logo-full.png"
      width={800}
      height={601}
      priority
      className={className ?? "h-24 w-auto"}
      alt="Horsink"
    />
  );
}
